export const PARAM_IFRAME_HEADER_TITLE = 'headerTitle' // chỉ xài ở iframe mini app
export const PARAM_IFRAME_URL = 'url' // chỉ xài ở iframe mini app
export const PARAM_IS_BACK_TO_HOME_MINI_APP = 'isBackToHomeMiniApp' // chỉ xài ở iframe mini app
export const MESSAGE_BACK_TO_HOME_MINI_APP = "BackToHomeMiniApp";  // PostMessage keys: chỉ xài ở iframe mini app
export const PARAM_BACK_TO_HOME_MINI_APP_URL = 'backToHomeMiniAppUrl' // Trang web trước khi chuyển href tới 1 trang mới

export const PARAM_IS_WEB_VIEW = 'isWebView'
export const PARAM_IS_HEADER_MINI_APP = 'isHeaderMiniApp';
export const PARAM_IS_HEADER_MINI_APP_EXPAND = 'isHeaderMiniAppExpand'

export const PARAM_REFER_USER_ID = 'referUserId' // id người giới thiệu
export const PARAM_REFER_STATION_ID = 'referStationId' // id trạm giới thiệu

export const PARAM_HOME_MINIAPP_CONSENT_MODE = 'homeMiniappConsentMode' // chế độ đồng ý của mini app trang chủ


